import { CPLocale } from 'src/orchd-client';
// ENGLISH GB
import day from 'dayjs';

import { dateFormat, dateTimeFormat, timeFormat } from 'src/translations/constants';
import messages from 'src/translations/messages/defaultMessages.json';

require('dayjs/locale/en');

const configureTimeLibraries = () => {
  day.locale(CPLocale.en_GB);
};

const dateTimeConfig = {
  dateTime: dateTimeFormat['DD/MM/YYYY HH:mm'],
  time: timeFormat['HH:mm'],
  date: dateFormat['DD/MM/YYYY'],
};

export { messages, configureTimeLibraries, dateTimeConfig };
